import type { ReactNode } from 'react'
import { cn } from '@/utils/cn'

export function MaxWidthWrapper({
  className,
  children,
}: {
  className?: string
  children: ReactNode
}) {
  return <div className={cn('mx-auto w-full px-2.5 lg:px-20', className)}>{children}</div>
}
